import request from '@/router/axios'
import env from '@/config/env'

/**
 * 获取当前登录用户所属供应商以及下属供应商
 * @param data
 *
 */
export const updateUnLockPermission = (data) => {
  return request({
    url: env.ferryUrl + `/merchant/lock/${data.merchantId}`,
    method: 'GET'
  })
}

/**
 * 获取当前登录用户所属供应商以及下属供应商
 * @param data
 *
 */
export const getMerchantList = () => {
  return request({
    url: env.ferryUrl + '/merchant/getMerchantList',
    method: 'GET'
  })
}
/**
 * 获取所有的业务类型
 * @param data
 *
 */
export const getBizType = () => {
  return request({
    url: env.ferryUrl + '/merchant/getBizType',
    method: 'GET'
  })
}
/**
 * 获取地区树
 * @param data
 *
 */
export const getDriverAreaTree = (data) => {
  return request({
    url: env.ferryUrl + '/driver/area-tree',
    method: 'GET',
    data
  })
}
/**
 * 获取科技公司供应商
 * @param data
 *
 */
export const getScienceMerchant = () => {
  return request({
    url: env.ferryUrl + '/merchant/scienceMerchant',
    method: 'GET'
  })
}

/**
 * 新增/编辑供应商
 * @param data
 *
 */
export const saveOrUpdate = (data) => {
  return request({
    url: env.ferryUrl + '/merchant/saveOrUpdate',
    method: 'POST',
    data
  })
}

/**
 * 获取供应商分页
 * @param data
 *
 */
export const getMerchantPage = (data) => {
  return request({
    url: env.ferryUrl + '/merchant/page',
    method: 'POST',
    data
  })
}

/**
 * 获取供应商信息
 * @param data
 *
 */
export const getMerchantInfo = (merchantId) => {
  return request({
    url: env.ferryUrl + `/merchant/getInfo/${merchantId}`,
    method: 'GET'
  })
}

/**
 * 删除供应商信息
 * @param data
 *
 */
export const deleteMerchant = (merchantId) => {
  return request({
    url: env.ferryUrl + `/merchant/delete/${merchantId}`,
    method: 'DELETE'
  })
}

/**
 * 根据区域查询区域站点
 * @param data
 *
 */
export const queryAreaStation = (data) => {
  return request({
    url: env.ferryUrl + '/stationManage/getStation',
    method: 'POST',
    data
  })
}

/**
 * 供应商绑定站点
 * @param data
 *
 */
export const bindStation = (data) => {
  return request({
    url: env.ferryUrl + '/merchantStationBind/bindStation',
    method: 'POST',
    data
  })
}

/**
 * 获取供应商绑定的站点
 * @param data
 *
 */
export const getStationsList = (merchantId) => {
  return request({
    url: env.ferryUrl + `/merchantStationBind/getStationsList?merchantId=${merchantId}`,
    method: 'GET'
  })
}

/**
 * 供应商解绑站点
 * @param data
 */
export const unBindStation = ({ merchantId, stationIds }) => {
  return request({
    url:
      env.ferryUrl +
      `/merchantStationBind/unBindStation?merchantId=${merchantId}&stationIds=${stationIds}`,

    method: 'DELETE'
  })
}

/**
 * 发票渠道配置
 */
export const invoiceChannelConfig = (data) => {
  return request({
    url: env.ferryUrl + '/invoice/channel-config/dealConfig',
    method: 'POST',
    data
  })
}

/**
 * 发票渠道配置列表
 */
export const invoiceChannelConfigList = (merchantId) => {
  return request({
    url: env.ferryUrl + `/invoice/channel-config/listByMerchantId?merchantId=${merchantId}`,
    method: 'GET'
  })
}
